import { useEffect, useState } from "react";
import React from "react";
import WoodButton from "./WoodButton";
import Container from "./Container";
import TokenList from "./TokenList";
import LoadingModal from "./LoadingModal";
import OutcomeModal from "./OutcomeModal";
import UnstakeModal from "./UnstakeModal";
import EthereumInteraction from "./EthereumInteraction";
import { parseClaims, stake, claim } from "../utils/barn";
import { parseBigNumber, watchTransaction } from "../utils/ethereum";
import { BigNumber } from "@ethersproject/bignumber";

const Menu = ({}) => {
    const onButton = async () => {
        const menu = document.querySelector("#mobile-menu");
        if (menu.classList.contains("sm:hidden")) {
            menu.classList.add("hidden");
            menu.classList.remove("sm:hidden");
            console.log(1);
        } else {
            menu.classList.add("sm:hidden");
            menu.classList.remove("hidden");
            console.log(0);
        }
    };
    return (
        <>
            <nav class="bg-brown fixed w-full z-10">
                <div class="mx-auto px-2 sm:px-6 lg:px-8">
                    <div class="relative flex items-center justify-between h-16">
                        <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
                            <button
                                type="button"
                                class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white mobile-menu-button"
                                aria-controls="mobile-menu"
                                aria-expanded="false"
                                onClick={() => {
                                    onButton();
                                }}
                            >
                                <span class="sr-only">Open main menu</span>
                                <svg class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
                                </svg>
                                <svg class="hidden h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            </button>
                        </div>
                        <div class="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                            <div class="flex-shrink-0 flex items-center">
                                <div class="title" style={{ fontSize: "24px" }}>
                                    AVAX Wolf Game
                                </div>
                            </div>
                            <div class="hidden sm:block sm:ml-6 flex items-center" style={{ marginTop: "20px" }}>
                                <div class="flex space-x-4 font-console">
                                    <a class="text-white px-3 pt-2 pb-3 text-sm font-medium nav-item-border nav-item-selected" aria-current="page" href="/">
                                        GAME
                                    </a>
                                    <a class="text-white px-3 pt-2 pb-3 text-sm font-medium nav-item-border" aria-current="page" href="/cows">
                                        avaCows are here !
                                    </a>
                                    <a class="text-white px-3 pt-2 pb-3 text-sm font-medium nav-item-border" aria-current="page" href="/whitepaper">
                                        Whitepaper
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hidden" id="mobile-menu">
                    <div class="px-2 pt-2 pb-3 space-y-1 font-console">
                        <a class="text-black hover:text-black block px-3 py-2 text-base font-medium" aria-current="page" href="/">
                            GAME
                        </a>
                        <a class="text-white hover:text-black block px-3 py-2 text-base font-medium" aria-current="page" href="/cows">
                            avaCows
                        </a>
                        <a class="text-white hover:text-black block px-3 py-2 text-base font-medium" aria-current="page" href="/whitepaper">
                            Whitepaper
                        </a>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Menu;
